// src/extenders/read-more-content.js
var ReadMoreContent = class extends HTMLElement {
  connectedCallback() {
    this.content = this.querySelector("[data-read-more-content]");
    this.trigger = this.querySelector("[data-read-more-trigger]");
    this.collapsedClasses = ["line-clamp-4", "lg:line-clamp-3"];
    if (!this.content || !this.trigger) {
      return;
    }
    this.expandHandler = this._expand.bind(this);
    this.resizeHandler = this._setTriggerVisibility.bind(this);
    this.trigger.addEventListener("click", this.expandHandler);
    this.resizeObserver = new ResizeObserver(this.resizeHandler);
    this.resizeObserver.observe(this.content);
    this._setTriggerVisibility();
  }
  disconnectedCallback() {
    var _a, _b;
    (_a = this.trigger) == null ? void 0 : _a.removeEventListener("click", this.expandHandler);
    (_b = this.resizeObserver) == null ? void 0 : _b.disconnect();
  }
  _setTriggerVisibility() {
    const isOverflowing = this.content.scrollHeight > this.content.clientHeight + 1;
    this.trigger.classList.toggle("hidden", !isOverflowing);
  }
  _expand() {
    this.content.classList.remove(...this.collapsedClasses);
    this.trigger.setAttribute("aria-expanded", "true");
    this.trigger.classList.add("hidden");
  }
};
if (!window.customElements.get("read-more-content")) {
  window.customElements.define("read-more-content", ReadMoreContent);
}
